import {rupiah} from 'utils/formatter'
import styles from './style.css'

class Total extends React.Component {
  render () {
    let {paymentDetail} = this.props
    return (<div className={styles['receipt-total']}>
      <div className={styles['receipt-total-box']}>
        <div className='pull-left'>Total</div>
        <div className='pull-right text-pre-wrap'>{ rupiah(paymentDetail.total_collected)}</div>
      </div>

      <div className='receipt-payment-box'>
        <div className='payment-method' style={{'height': '30px'}}>
          {paymentDetail.payment_type !== 'card' && <div className='pull-left'>
            { paymentDetail.payment_type_label }
          </div>}

          {paymentDetail.payment_type === 'card' && <div className='pull-left'>
            Card
          </div>}

          <div className='pull-right'>{ rupiah(paymentDetail.tendered)}</div>
        </div>

        <div className='payment-method' style={{'textAlign': 'left'}}>
          <div className='payment-note'>
            {paymentDetail.payment_note && paymentDetail.payment_type !== 'cash' && paymentDetail.payment_type !== 'card' && <div className={styles['overflow-word']}>
              { paymentDetail.payment_note }
            </div>}

            {paymentDetail.payment_type === 'card' && paymentDetail.card_type && <div className='pull-left'>
              {paymentDetail.card_type } - { paymentDetail.card_no }
            </div>}

            {paymentDetail.payment_type === 'card' && !paymentDetail.card_type && <div className='pull-left'>
              Debit/Credit - {paymentDetail}
            </div>}
          </div>
        </div>

        {paymentDetail.payment_type === 'cash' && <div className='payment-change'>
          <div className='pull-left'>Change</div>
          <div className='pull-right'>{rupiah(paymentDetail.change)}</div>
        </div>}
      </div>
    </div>)
  }
}

Total.propTypes = {
  paymentDetail: React.PropTypes.object
}

export default Total



// WEBPACK FOOTER //
// ./app/components/receipt/transactions/Total/Total.js